import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  pageValue: 1,
};
export const pageSlice = createSlice({
  name: "page",
  initialState,
  reducers: {
    updatePage: (state, action) => {
      state.pageValue = action.payload;
    },
  },
});

export const { updatePage } = pageSlice.actions;
export default pageSlice.reducer;
